const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/MediPage/MediPage.tsx';
import { PageLayout } from '../../layout/PageLayout';
import { AppBarMain } from '../DashboardPage/AppBar/AppBar';
import { useMedicationData } from 'App/store/medication';
import { MedicationList } from 'App/components/Medication/MedicationList';
import { EmptyState } from 'App/components/EmptyState/EmptyState';
import textMap from 'App/pages/MediPage/translations';
import { css } from '@emotion/css';
import * as React from 'react';
import LoadingSpinner from '@cistec/common_web/components/LoadingSpinner';

export interface IMediPageProps {}

const cssMediList = css`
    flex: 1 1 auto;
`;
const cssEmptyState = css`
    text-align: center;
`;

export const MediPage = (props: IMediPageProps) => {
    const [medications, isLoadingMedications] = useMedicationData();

    const hasMedications = medications && medications.length > 0;

    const getContent = () => {
        if (isLoadingMedications) {
            return (
                <div className={cssEmptyState}>
                    <LoadingSpinner />
                </div>
            );
        } else if (hasMedications) {
            return (
                <div className={cssMediList}>
                    <MedicationList medications={medications} />
                </div>
            );
        } else {
            return (
                <div className={cssEmptyState}>
                    <EmptyState intlText={textMap.noMedication} />
                </div>
            );
        }
    };

    return <PageLayout appBar={<AppBarMain />}>{getContent()}</PageLayout>;
};
